<div class="progress-bar-container">
  <mat-progress-bar
    mode="indeterminate"
    *ngIf="loading"
    color="primary"
  ></mat-progress-bar>
</div>
<div class="data-grid-container" [ngClass]="gridContainerClass">
  <table
    mat-table
    [dataSource]="source.items"
    matSort
    [matSortDisableClear]="true"
    [matSortActive]="getOrderByField()"
    [matSortDirection]="source.orderDir"
    (matSortChange)="handleSort($event)"
    class="data-grid card-list-table-inactive"
    [ngClass]="{ 'table-fixed-layout': fixedLayout }"
    [ngStyle]="{ width: tableWidth ? tableWidth + 'px' : '100%' }"
    multiTemplateDataRows
  >
    <ng-container matColumnDef="row-index-column">
      <th
        mat-header-cell
        *matHeaderCellDef
        [attr.rowSpan]="2"
        [ngClass]="{ 'p-l-15': expandableRows }"
        class="grid-header grid-header-expandable-button"
      >
        N°
      </th>
      <td
        mat-cell
        class="grid-column grid-column-expandable-button"
        [ngClass]="{ 'p-l-15': expandableRows }"
        *matCellDef="let rowIndex = dataIndex"
      >
        {{ this.calcNroRow(rowIndex) }}
      </td>
    </ng-container>
    <ng-container matColumnDef="expandable-button-column">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="grid-header grid-header-expandable-button"
      ></th>
      <td
        mat-cell
        class="grid-column grid-column-expandable-button"
        *matCellDef="let i = dataIndex"
      >
        <button
          mat-icon-button
          color="primary"
          (click)="toogleExpandableRow(i)"
        >
          <mat-icon>
            {{
              isRowExpanded(i) ? "keyboard_arrow_down" : "keyboard_arrow_right"
            }}
          </mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container
      [matColumnDef]="item['field']"
      [sticky]="item.sticky || false"
      *ngFor="let item of definition.columns"
    >
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        [disabled]="!item.sortable || loading"
        [attr.rowSpan]="item.thRowSpan || 1"
        [attr.colSpan]="item.thColSpan || 1"
        class="grid-header"
        [ngStyle]="item.thStyle"
        [ngClass]="{
          'cell-flex': item.buttons,
          'cell-break-word': !item.buttons
        }"
      >
        {{ item.label }}
      </th>
      <td
        mat-cell
        [attr.data-title]="item.label"
        data-title="Column #1"
        *matCellDef="let element; let rowIndex = dataIndex"
        [attr.data-label]="item.label"
        [ngStyle]="item.tdStyle"
        [ngClass]="{ 'cell-flex': item.buttons }"
      >
        <lib-grid-body-column
          [rowIndex]="rowIndex"
          [colDef]="item"
          [element]="element"
          [template]="customTemplates[item['template']]"
          [loading]="loading"
        >
        </lib-grid-body-column>
      </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td
        mat-cell
        *matCellDef="let element; let i = dataIndex"
        [attr.colspan]="displayedColumns.length"
      >
        <div
          class="grid-element-detail"
          [@detailExpand]="
            expandableTemplate && isRowExpanded(i) ? 'expanded' : 'collapsed'
          "
        >
          <div *ngIf="isRowExpanded(i)" [@enterAnimation]>
            <ng-template
              *ngTemplateOutlet="
                expandableTemplate;
                context: {
                  $implicit: element
                }
              "
            ></ng-template>
          </div>
        </div>
      </td>
    </ng-container>

    <tbody>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

      <tr
        mat-row
        class="grid-element-row {{ i % 2 == 0 ? 'odd' : 'even' }}"
        *matRowDef="let row; let i = dataIndex; columns: displayedColumns"
      ></tr>

      <tr
        mat-row
        *matRowDef="let row; columns: ['expandedDetail']"
        class="grid-detail-row"
      ></tr>
    </tbody>
  </table>

  <div
    class="empty-rows mat-typography"
    *ngIf="
      variant == gridType.SERVER &&
      source.total == 0 &&
      !loading &&
      !serverError
    "
  >
    {{ emptyRowsMsg }}
  </div>

  <div
    class="empty-rows mat-typography"
    *ngIf="
      variant == gridType.LIST &&
      source.items.length == 0 &&
      !serverError &&
      !loading
    "
  >
    {{ emptyRowsMsg }}
  </div>

  <div class="empty-rows mat-typography" *ngIf="serverError">
    Ocurrió un error al cargar los datos
  </div>

  <lib-grid-skeleton *ngIf="loading && source.total == 0"></lib-grid-skeleton>

  <lib-grid-paginator
    *ngIf="variant == gridType.SERVER && source.total > 0 && !serverError"
    [disabled]="loading"
    (on-change-page)="handleChangePage($event)"
    (on-change-page-size)="handleChangePageSize($event)"
    [total]="source.total"
    [pageSize]="source.pageSize"
    [page]="source.page"
    [pageSizeOptions]="pageSizeOptions"
    [pageLength]="source.items.length"
    [hideNumberButtons]="hideNumberButtons"
  >
  </lib-grid-paginator>
</div>
